// Registry of data-driven simulators that run on the shared BeatEngine.
import { conflictConfig } from "./sims/conflict";
import { dispensingConfig } from "./sims/dispensing";
import { radiographyConfig } from "./sims/radiography";
import { asepsisConfig } from "./sims/asepsis";
import { griefConfig } from "./sims/grief";
import { emergencyConfig } from "./sims/emergency";
import { infectionConfig } from "./sims/infection";
import { receptionConfig } from "./sims/reception";
import { anaesCrisisConfig } from "./sims/anaesCrisis";

export const SIM_CONFIGS = {
  conflict: conflictConfig,
  dispensing: dispensingConfig,
  radiography: radiographyConfig,
  asepsis: asepsisConfig,
  grief: griefConfig,
  emergency: emergencyConfig,
  infection: infectionConfig,
  reception: receptionConfig,
  anaescrisis: anaesCrisisConfig,
};

export const ENGINE_SIMS = Object.values(SIM_CONFIGS);
